import { Injectable, inject } from "@angular/core";
import { CookieService } from "src/app/services/cookie.service";
import { switchMap, tap } from "rxjs/operators";
import { EndpointService } from "src/app/services/endpoint.service";
import { catchError, Observable, of, throwError } from "rxjs";
import { SessionStorageService, StorageKey } from "src/app/services/session-storage.service";

@Injectable({
  providedIn: "root",
})
export class DataTrackingService {
  private readonly endpointService = inject(EndpointService);
  private readonly cookieService = inject(CookieService);
  private readonly sessionStorageService = inject(SessionStorageService);

  public sendDataTracking(): Observable<unknown> {
    if (this.hasSendDataTrackingSent()) {
      return of(null);
    }

    return this.endpointService.composeSendDataTrackingUrl().pipe(
      switchMap((url) => {
        return this.endpointService
          .httpPost$(url, {
            body: {
              stbId: this.getStbId(),
            },
          })
          .pipe(
            catchError((error) => {
              if (error.status === 401) {
                return of(null);
              }
              return throwError(() => error); // Propagate other errors
            }),
            tap(() => this.setSendDataTrackingSent()),
          );
      }),
    );
  }

  private setSendDataTrackingSent(): void {
    this.sessionStorageService.set(StorageKey.DataTrackingSent, true);
  }

  private hasSendDataTrackingSent(): boolean {
    return Boolean(this.sessionStorageService.get(StorageKey.DataTrackingSent, false));
  }

  private getStbId(): string {
    return this.cookieService.getOrCreateStbId();
  }
}
